var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShieldTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 104,
    viewBox: "0 0 91 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 36,
    r: 36,
    fill: "#FFEBC4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.9302 9.0814L12.7209 17.8256C7.37209 19.8256 3 26.1512 3 31.8256V66.3837C3 71.8721 6.62791 79.0814 11.0465 82.3837L31.0465 97.314C37.6046 102.244 48.3953 102.244 54.9535 97.314L74.9535 82.3837C79.3721 79.0814 83 71.8721 83 66.3837V31.8256C83 26.1047 78.6279 19.7791 73.2791 17.7791L50.0698 9.0814C46.1163 7.63953 39.7907 7.63953 35.9302 9.0814Z",
    stroke: "#395966",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2324 53.9181L36.7208 61.4065L56.7208 41.4065",
    stroke: "#FCBE1F",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldTick);
export default __webpack_public_path__ + "static/media/shieldTick.24e6f499b1e4e99422f426972d73548c.svg";
export { ForwardRef as ReactComponent };